import { application } from "./application"

import SortableController from "./sortable_controller"
import VideoPlayerController from "./video_player_controller"
import TiptapController from "./tiptap_controller"
import ModalController from "./modal_controller"
import FlashController from "./flash_controller"
import HeroLayoutController from "./hero_layout_controller"
import MuxPlayerController from "./mux_player_controller"
import SidebarScrollController from "./sidebar_scroll_controller"
import QuizBuilderController from "./quiz_builder_controller"
import ModalAutoCloseController from "./modal_auto_close_controller"
import RevenueChartController from "./revenue_chart_controller"
import DismissibleController from "./dismissible_controller"
import WizardSectionsController from "./wizard_sections_controller"
import MediaPickerController from "./media_picker_controller"
import FileDropController from "./file_drop_controller"
import PollController from "./poll_controller"

application.register("sortable", SortableController)
application.register("video-player", VideoPlayerController)
application.register("tiptap", TiptapController)
application.register("modal", ModalController)
application.register("flash", FlashController)
application.register("hero-layout", HeroLayoutController)
application.register("mux-player", MuxPlayerController)
application.register("sidebar-scroll", SidebarScrollController)
application.register("quiz-builder", QuizBuilderController)
application.register("modal-auto-close", ModalAutoCloseController)
application.register("revenue-chart", RevenueChartController)
application.register("dismissible", DismissibleController)
application.register("wizard-sections", WizardSectionsController)
application.register("media-picker", MediaPickerController)
application.register("file-drop", FileDropController)
application.register("poll", PollController)
